import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import ReactMoment from 'react-moment';
import {dateFormatsListItems, minDate} from '../../../util/uiconstants';

const UserDate = (props) => {
	const userDateFormat = useSelector((store) => store.userPreferences.dateFormat);

	const getFormat = () => {
		let format = dateFormatsListItems[0].label;
		if (dateFormatsListItems.find((x) => x.label === userDateFormat)) {
			format = userDateFormat;
		}
		return format;
	};

	const isValidDate = () => {
		return props.date.length > 0 && props.date !== minDate;
	};

	return isValidDate() && <ReactMoment format={getFormat()}>{props.date}</ReactMoment>;
};

UserDate.defaultProps = {
	date: ''
};

UserDate.propTypes = {
	date: PropTypes.string.isRequired
};

export default UserDate;
